<template>
  <v-layout v-if="summary" row wrap>
    <v-flex xs12 sm12 md8>
      <!-- Currency -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">{{
          $t("screener.table.header.currency")
        }}</v-flex>
        <v-flex xs6>
          <div>
            <span>{{ summary.currency }}</span>
            <v-tooltip top color="white">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="px-2"
                  >mdi-information-outline</v-icon
                >
              </template>
              <div class="greyDarken3--text body-1">
                {{ $t("screener.revenue_summary.currency.tooltip") }}
              </div>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
      <!-- Total Revenue -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text"
          >{{ $t("screener.table.header.total_revenue") }}
        </v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.total_revenue">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ parseFloat(summary.total_revenue) + parseFloat(summary.affiliation_revenue) | fixed  }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  {{ $t("screener.revenue_summary.total_revenue.tooltip") }}
                </div>
              </v-tooltip>
            </span>

            <span v-else>{{ $t("rms.not_available") }}</span>
          </div>
        </v-flex>
      </v-layout>
      <!-- Organization Total Revenue -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">{{
          $t("screener.revenue_summary.organization_total_revenue.title")
        }}</v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.total_company_revenue">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.total_company_revenue | fixed }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  {{
                    $t(
                      "screener.revenue_summary.organization_total_revenue.tooltip"
                    )
                  }}
                </div>
              </v-tooltip>
            </span>

            <span v-else>{{ $t("rms.not_available") }}</span>
          </div>
        </v-flex>
      </v-layout>
      <!-- Right Holders Total Revenue -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">{{
          $t("screener.revenue_summary.right_holder_total_revenue.title")
        }}</v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.total_right_holder_revenue">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.total_right_holder_revenue | fixed }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  {{
                    $t(
                      "screener.revenue_summary.right_holder_total_revenue.tooltip"
                    )
                  }}
                </div>
              </v-tooltip>
            </span>

            <span v-else>{{ $t("rms.not_available") }}</span>
          </div>
        </v-flex>
      </v-layout>

      <!-- Affiliation Revenue -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">{{
          $t("screener.revenue_summary.affiliation_revenue.title")
        }}</v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.affiliation_revenue">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.affiliation_revenue | fixed }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  {{
                    $t(
                      "screener.revenue_summary.affiliation_revenue.tooltip"
                    )
                  }}
                </div>
              </v-tooltip>
            </span>

            <span v-else>{{ $t("rms.not_available") }}</span>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="my-3"></v-divider>

      <!-- Total Paid Revenue -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">Total Payouts Made</v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.total_paid_revenue">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.total_paid_revenue - summary.other_cost | fixed }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  Revenue that has been paid to the organization
                </div>
              </v-tooltip>
              <v-chip small class="mr-2" v-if="!isSAPanel"
                @click="
                  $router.push({
                    name: 'payout.index',
                    params: {
                      selectedType: {
                        name: $t('screener.payout_type.client_payout'),
                        value: DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT,
                      },
                    },
                  })
                "
              >
                View All Payouts
              </v-chip>
            </span>

            <span v-else>{{ currency_symbol }}&nbsp;0.00</span>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="my-3"></v-divider>
      <!-- Available for payout -->
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">Rolled over balance (cost of refunds, gateway fees etc.) </v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.other_cost">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.other_cost }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  Cost of refund fee/dispute/adjustment against any partial refund or dispute
                </div>
              </v-tooltip>
            </span>
            <span v-else>{{ currency_symbol }}&nbsp;0.00</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">Requested for Payout</v-flex>
        <v-flex xs6>
          <div>
            <span v-if="summary.payout_requested">
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.payout_requested }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  Amount for which you have already made a payout request
                </div>
              </v-tooltip>
            </span>
            <span v-else>{{ currency_symbol }}&nbsp;0.00</span>
            <v-chip small class="mr-2" v-if="!isSAPanel && summary.payout_requested"
                @click="
                  $router.push({
                    name: 'payout.index',
                    params: {
                      selectedStatus: {
                        name: $t('screener.payout_status.requested'),
                        value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.REQUESTED,
                      },
                    },
                  })
                "
              >
                View Requested Payouts
              </v-chip>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="py-1 subheading">
        <v-flex xs6 class="greyDarken1--text">Available for payout</v-flex>
        <v-flex xs6>
          <div>
            <span>
              <span>{{ currency_symbol }}&nbsp;</span>
              <span>{{ summary.total_unpaid_revenue| fixed }}</span>
              <v-tooltip top color="white">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="px-2"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <div class="greyDarken3--text body-1">
                  Revenue that has to be paid to the organization (Available for payout = Total Revenue + Affiliation Revenue - Total Payouts requested - Total Payouts made - Rolled over balance)
                </div>
              </v-tooltip>
            </span>
          </div>
        </v-flex>
        <v-flex xs12 v-if="!isSAPanel">
          <h6>Disclaimer - Unpaid amount could be changed due to any refund cost/unsettled dispute penalty/adjustment</h6>
        </v-flex>
        <v-flex xs12 v-else>
          <h6>(Available for payout = Total Revenue + Affiliation Revenue - Total Requested Payouts - Total Completed Payouts - Rolled over balance)</h6>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- v-if="parseFloat(this.summary.total_unpaid_revenue) > 0" -->
    <v-layout row wrap justify-end>
      <v-btn class="mx-0" v-if="isSuperAdmin && isSAPanel" @click.stop="onBeforeMarkRevenuePaid(DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT)" color="secondary">
        {{ $t("screener.admin.company.revenue.mark_paid") }}
      </v-btn>
      <v-btn class="mx-2" v-if="isSuperAdmin && isSAPanel" @click.stop="onBeforeMarkRevenuePaid(DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT)" color="secondary">
        {{ $t("screener.admin.company.revenue.create_adjustment") }}
      </v-btn>
      <RequestPayout v-else-if="userRoleInCompany >= DEFINES.ROLE_ADMIN && summary.total_unpaid_revenue && parseFloat(summary.total_unpaid_revenue) > 0"
        :unpaid_revenue="summary.total_unpaid_revenue"
         :currency_symbol="currency_symbol"
         @onConfirm="getRevenueSummary">
      </RequestPayout>
     </v-layout>
     <ConfirmPayout
        :unpaid_amount.sync="unpaid_amount"
        :payout_amount.sync="payout_amount"
        :currency_symbol="currency_symbol"
        :client_note.sync="client_note"
        :admin_note.sync="admin_note"
        :type="payout_type"
        :dialog="show_payout_confirmation"
        @onCancel="show_payout_confirmation = false"
        @onConfirm="confirmRevenePaid"
        >
      </ConfirmPayout>
     <ConfirmationDialog
      v-if="dialog"
      :dialog="dialog"
      @confirm="markRevenuePaid"
      @cancel="dialog = false"
    ></ConfirmationDialog>
  </v-layout>
  <v-layout v-else class="pa-5" justify-center align-center>
    <div class="greyDarken1--text">Please wait...</div>
  </v-layout>
</template>

<script>
import i18n from "@/i18n";
import { mapGetters } from "vuex";
import { currencySymbol } from "@/mixins/monetization";
import RequestPayout from "./RequestPayout";
import ConfirmationDialog from '@/components/dialogBox/Confirmation';
import ConfirmPayout from "./ConfirmPayout";
import DEFINES from '@/defines';

export default {
  name: "RevenueSummary",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getRevenueSummary();
    });
  },
  props: {
    isSAPanel: {
      type: Boolean,
      default: false,
    },
    companyId:{
      type: Number,
      default: 0
    }
  },
  components: {
    RequestPayout,
    ConfirmationDialog,
    ConfirmPayout
  },
  data() {
    return {
      summary: null,
      currency_symbol: null,
      dialog:false,
      client_note : null,
      admin_note : null,
      unpaid_amount : null,
      show_payout_confirmation: false,
      payout_type:null,
      payout_amount: null
    };
  },
  mixins: [currencySymbol],
  mounted() {
    this.getRevenueSummary();
  },
  computed: {
    ...mapGetters({
      selected_company_id: "company/getSelected",
      isSuperAdmin: "user/isSuperAdmin",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
  methods: {
    confirmRevenePaid(){
      this.show_payout_confirmation = false;
      this.dialog = true;
      this.payout_type = type;
    },
    async getRevenueSummary() {
      try {
        var response = await this.$store.dispatch("revenue/getSummary", {
          company_id:this.companyId
        });
        this.summary = response.revenue_summary;
        this.currency_symbol = this.getCurrencySymbol(
          response.revenue_summary.currency
        );
        this.unpaid_amount = this.summary.total_unpaid_revenue;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async onBeforeMarkRevenuePaid (type){
      this.payout_type = type;
      this.show_payout_confirmation = true;
    },
    async markRevenuePaid() {
      try {
         if(this.payout_type == DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT){
            var response = await this.$store.dispatch("adminRevenue/markRevenuePaid",{
              company_id:this.companyId,
              unpaid_amount:this.unpaid_amount,
              client_note:this.client_note,
              admin_note:this.admin_note
            });
         }else if(this.payout_type == DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT){
            var response = await this.$store.dispatch("monetization/addPayout",{
              company_id:this.companyId,
              amount:this.payout_amount,
              client_note:this.client_note,
              admin_note:this.admin_note,
              type:this.payout_type,
              is_revenue_summary_needed:true
            });
         }
         this.summary = response.revenue_summary;
         if (this.payout_type == DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT) {
            this.$store.dispatch("app/showMessage", {
              message: i18n.t('screener.admin.company.revenue.mark_paid_success_msg'),
              color: "success",
            });
          } else if (this.payout_type == DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT) {
            await this.$store.dispatch('app/showMessage', {
              message: i18n.t('screener.adjustment.success'),
              color: 'success',
            });
          }
          this.dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }finally{
        this.payout_type = null;
        this.payout_amount = null;
        this.unpaid_amount = this.summary.total_unpaid_revenue
        this.client_note = null;
        this.admin_note = null;
      }
    },
  },
};
</script>

<style></style>
